<template>
    <button
        v-if="!form.formula_rate"
        type="button"
        :class="[
            ' mt-6 h-10 w-full rounded-md text-white',
            !form.issuer_country || !form.target
                ? 'cursor-not-allowed bg-gray-300'
                : 'bg-primary-accent-500 cursor-pointer',
        ]"
        :disabled="!form.issuer_country || !form.target"
        @click="emit('openFormulaModal', { type: 'rate' })"
    >
        {{ form.formula_rate ? $t('edit') : $t('create') }}
        {{ $t('tax_formula_rate') }}
    </button>
    <div
        v-else
        class="relative my-6 flex h-auto w-full flex-col items-start justify-start space-y-2"
    >
        <p class="text-sm font-medium">
            {{ $t('tax_formula_rate') }}
        </p>
        <div
            class="flex h-10 w-full items-center justify-center rounded-md border border-gray-300 px-0.5"
        >
            <input
                v-if="form.formula_rate"
                v-model="form.formula_rate"
                readonly
                class="h-9 w-full rounded-md border-none px-2 focus:outline-none focus:ring-0"
            />
            <EditButton @click="emit('openFormulaModal', { type: 'rate' })" />
        </div>
    </div>
    <div class="my-6 h-px w-full rounded-full bg-gray-300"></div>
    <button
        v-if="!form.formula_amount"
        type="button"
        :class="[
            ' h-10 w-full rounded-md text-white',
            !form.issuer_country || !form.target
                ? 'cursor-not-allowed bg-gray-300'
                : 'bg-primary-accent-500 cursor-pointer',
        ]"
        :disabled="!form.issuer_country || !form.target"
        @click="emit('openFormulaModal', { type: 'amount' })"
    >
        {{ form.formula_amount ? $t('edit') : $t('create') }}
        {{ $t('tax_formula_amount') }}
    </button>
    <div
        v-else
        class="relative my-6 flex h-auto w-full flex-col items-start justify-start space-y-2"
    >
        <p class="text-sm font-medium">
            {{ $t('tax_formula_amount') }}
        </p>
        <div
            class="flex h-10 w-full items-center justify-center rounded-md border border-gray-300 px-0.5"
        >
            <input
                v-if="form.formula_amount"
                v-model="form.formula_amount"
                readonly
                class="h-9 w-full rounded-md border-none px-2 focus:outline-none focus:ring-0"
            />
            <EditButton @click="emit('openFormulaModal', { type: 'amount' })" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useTaxesStore } from '@src/utils/stores/taxes'
import { storeToRefs } from 'pinia'
import EditButton from '../actions/EditButton.vue'

const emit = defineEmits(['openFormulaModal'])

const taxStore = useTaxesStore()
const { taxForm: form } = storeToRefs(taxStore)
</script>
